<template>
  <div class="team-info-warp">
    <div class="team-members">
      <check-users-warp :check-list="checkList" flex-basis="25%">
        <template v-slot:check-users-item-add="{ itemStyle }">
          <check-user-item-add v-if="team.validToCurrentUser" :item-style="itemStyle" />
          <check-user-item-remove :item-style="itemStyle" v-if="memberType === 'owner' || memberType === 'manager'" />
        </template>
      </check-users-warp>
    </div>
    <div class="team-info">
      <div class="item-info-item">
        <div class="team-name-label">群聊名称</div>
        <el-input class="m-item-name-input" v-model="team.name" size="mini" :disabled="memberType !== 'owner' && memberType !== 'manager'" @change="changeTeamName"></el-input>
      </div>
      <div class="item-info-item">
        <div class="team-name-label">群公告</div>
        <el-input class="m-item-name-input" v-model="team.announcement" size="mini" :disabled="memberType !== 'owner' && memberType !== 'manager'" @change="changeAnnouncement"></el-input>
      </div>
    </div>
    <div class="team-info" v-if="memberType !== 'owner'">
      <div class="item-info-item leave-team" @click="quitTeam">
        <span v-if="team.validToCurrentUser">退出群聊</span>
        <span v-else>删除会话</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CheckUsersWarp from './CheckUsersWarp'
import CheckUserItemAdd from './CheckUserItemAdd'
import CheckUserItemRemove from './CheckUserItemRemove'
export default {
  name: 'TeamInfo',
  components: { CheckUserItemAdd, CheckUsersWarp, CheckUserItemRemove },
  props: {
    team: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      imUserProfiles: state => state.imUserProfiles,
      imQyhContactData: state => state.imQyhContactData,
      imAccount: state => state.imAccount,
      imTeamMemberCheckList: state => state.imTeamMemberCheckList,
      imTeamAddMemberCheckList:state => state.imTeamAddMemberCheckList
    })
  },
  watch: {
    teamMembers: {
      handler (newValue) {
        this.checkList = this.imQyhContactData.filter(contact =>
          newValue.some(member => member.account === contact.im_accid)
        )
        let found = newValue.find(item => item.account === this.imAccount.im_accid)
        this.memberType = found ? found.type: ''
        this.filterCheckList(this.checkList, this.memberType)
        // this.$store.dispatch('changeImTeamMemberCheckListAction', checkList)
      },
      immediate: true,
      deep: true
    },
    team: {
      handler (newValue) {
        if (newValue.validToCurrentUser) {
          this.localGetMembers()
        } else {
          this.teamMembers = []
        }
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      notifyVisible: true,
      teamMembers: [],
      checkList: [],
      memberType: ''
    }
  },
  methods: {
    ...mapActions(['getTeamMembers', 'updateTeam', 'leaveTeam', 'handleLeaveTeam', 'imConfirm', 'deleteLocalSession']),
    async localGetMembers () {
      this.teamMembers = await this.getTeamMembers(this.team.teamId)
    },
    filterCheckList (checkList, memberType) {
      const filterList = checkList.filter(checkItem => {
        const member = this.teamMembers.find(teamMember => teamMember.account === checkItem.im_accid)
        if (memberType === 'owner') {
          return member && member.type !== 'owner'
        } else {
          return member && member.type !== 'owner' && member.type !== 'manager'
        }
      })

      this.$store.dispatch('changeImTeamMemberCheckListAction', filterList)

      const teamMemberAccounts = this.teamMembers.map(member => member.account)
      const filterAddList = this.imQyhContactData.filter(contact => !teamMemberAccounts.includes(contact.im_accid))
      this.$store.dispatch('changeImTeamAddMemberCheckListAction', filterAddList)
    },
    changeTeamName (val) {
      if (val) {
        let custom = this.imAccount.im_name + '将群名修改为' + this.team.name
        this.updateTeam({ teamInfo: this.team, custom: custom })
      } else {
        this.$message.error('名称不能为空')
      }
    },
    changeAnnouncement () {
      let custom = this.imAccount.im_name + '将公告修改为' + this.team.announcement
      this.updateTeam({ teamInfo: this.team, custom: custom })
    },
    quitTeam () {
      if (this.team.validToCurrentUser) {
        this.imConfirm('将退出群' + '"' + this.team.name + '"')
          .then(() => {
            this.leaveTeam({ teamId: this.team.teamId })
          }).catch(() => {
          console.log('Cancelled')
        })
      } else {
        this.handleLeaveTeam({ teamId: this.team.teamId, teamDismissed: true })
      }

    }
  }
}
</script>

<style lang="stylus" scoped>
.team-info-warp {
  font-size: 12px;
  padding: 10px;
}
.team-members {
  color: #999;
  border-bottom: 1px solid #ded9d9;
}
.check-users-warp {
  overflow-y: auto;
}
.check-users {
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
}
.check-users-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  flex: 1 0 33.3%;
  max-width: 33.3%;
  margin-bottom: 10px;
}
.team-info {
  border-bottom: 1px solid #ded9d9;
}
.item-info-item {
  padding: 10px;
}
.m-item-name-input >>> .el-input__inner {
  height: 25px;
  line-height: 25px;
  background-color: #f3f3f3;
  padding: 0;
  border: 1px solid #f3f3f3;
  color: #999;
}
.m-item-name-input >>> .el-input__inner:focus {
  border: 1px solid #409EFF;
}
.item-info-item >>> .el-input.is-disabled .el-input__inner {
  background-color: #f3f3f3;
  border-color: #f3f3f3;
  color: #999;
}
.team-name-label {
  line-height: 15px;
}
.leave-team {
  text-align: center;
  color: #fa5251;
  cursor: pointer;
}
.leave-team:active {
  background-color: #ccc
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/TeamInfo.vue